<div>
  <nz-page-header class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title class="text-primary flex items-center gap-2">
      {{ 'settings.title' | transloco }}
      <nz-icon
        nz-tooltip
        nzTooltipPlacement="right"
        [nzTooltipArrowPointAtCenter]="true"
        [nzTooltipTitle]="'nav.featureTooltips.setting' | transloco"
        [nzTooltipOverlayStyle]="{
          'max-width': '400px',
          'min-width': '300px',
          'white-space': 'normal',
          'line-height': '1.5'
        }"
        nz-icon
        nzType="info-circle"
        nzTheme="outline">
      </nz-icon>
    </nz-page-header-title>
  </nz-page-header>
</div>
<div>
  <nz-tabset nzLinkRouter [nzTabBarGutter]="8" [nzAnimated]="false">
    <nz-tab>
      <a
        *nzTabLink
        nz-tab-link
        [routerLink]="['.']"
        [queryParams]="{ tab: SETTINGS.SETTINGS_TAB_KEYS.ACCOUNT }"
        queryParamsHandling="merge">
        {{ 'settings.tabs.account' | transloco }}
      </a>
      <ng-container *ngIf="this.tabRef === SETTINGS.SETTINGS_TAB_KEYS.ACCOUNT">
        <app-account></app-account>
      </ng-container>
    </nz-tab>
    <nz-tab *appHasAnyPrivilege="'SETTING.COMPANY.INFORMATION.UPDATE'">
      <a
        *nzTabLink
        nz-tab-link
        [routerLink]="['.']"
        [queryParams]="{ tab: SETTINGS.SETTINGS_TAB_KEYS.BRANDING }"
        queryParamsHandling="merge">
        {{ 'settings.tabs.branding' | transloco }}
      </a>
      <ng-container *ngIf="this.tabRef === SETTINGS.SETTINGS_TAB_KEYS.BRANDING">
        <app-branding></app-branding>
      </ng-container>
    </nz-tab>

    <nz-tab *appHasAnyPrivilege="'SETTING.VIEW.PREFERENCES'">
      <a
        *nzTabLink
        nz-tab-link
        [routerLink]="['.']"
        [queryParams]="{ tab: SETTINGS.SETTINGS_TAB_KEYS.PREFERENCES }"
        queryParamsHandling="merge">
        {{ 'settings.tabs.preferences' | transloco }}
      </a>
      <ng-container
        *ngIf="this.tabRef === SETTINGS.SETTINGS_TAB_KEYS.PREFERENCES">
        <app-preferences></app-preferences>
      </ng-container>
    </nz-tab>

    <nz-tab *appHasAnyPrivilege="'SETTING.BILLING'">
      <a
        *nzTabLink
        nz-tab-link
        [routerLink]="['.']"
        [queryParams]="{ tab: SETTINGS.SETTINGS_TAB_KEYS.BILLING }"
        queryParamsHandling="merge">
        {{ 'settings.tabs.billing' | transloco }}
      </a>
      <ng-container *ngIf="this.tabRef === SETTINGS.SETTINGS_TAB_KEYS.BILLING">
        <app-billing></app-billing>
      </ng-container>
    </nz-tab>
  </nz-tabset>
</div>
<router-outlet></router-outlet>
